// zimtra links
export const ABOUT_ZIMTRA = "https://zimtra.ky/";
export const FAQ = "https://zimtra.ky/faq/";
export const CONTACT_US = "https://zimtra.ky/contact/";
export const PRIVACY_POLICY = "https://zimtra.ky/privacy-policy/";